var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H4.2C5.88016 0 6.72024 0 7.36197 0.32698C7.92646 0.614601 8.3854 1.07354 8.67302 1.63803C9 2.27976 9 3.11984 9 4.8V5.8C9 6.9201 9 7.48016 8.78201 7.90798C8.59027 8.28431 8.28431 8.59027 7.90798 8.78201C7.48016 9 6.9201 9 5.8 9H4.8C3.11984 9 2.27976 9 1.63803 8.67302C1.07354 8.3854 0.614601 7.92646 0.32698 7.36197C0 6.72024 0 5.88016 0 4.2V3.2Z",
    fill: "#36A6A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.6C2 3.03995 2 2.75992 2.10899 2.54601C2.20487 2.35785 2.35785 2.20487 2.54601 2.10899C2.75992 2 3.03995 2 3.6 2H3.8C4.9201 2 5.48016 2 5.90798 2.21799C6.28431 2.40973 6.59027 2.71569 6.78201 3.09202C7 3.51984 7 4.0799 7 5.2V5.4C7 5.96005 7 6.24008 6.89101 6.45399C6.79513 6.64215 6.64215 6.79513 6.45399 6.89101C6.24008 7 5.96005 7 5.4 7H5.2C4.0799 7 3.51984 7 3.09202 6.78201C2.71569 6.59027 2.40973 6.28431 2.21799 5.90798C2 5.48016 2 4.9201 2 3.8V3.6Z",
    fill: "#36A6A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsPoint);
export default __webpack_public_path__ + "static/media/statsPoint.09071f9e5cc786dc2550cbdfae91e69c.svg";
export { ForwardRef as ReactComponent };